import React from 'react'
import Moment from 'react-moment'

export default function DateCard({data}) {
  return (
    <>
        <div className="w-full mb-6 shadow-md rounded-lg bg-[#ecf5fe] cursor-pointer">
          <h3 className="rounded-t-lg text-lg font-semibold bg-[#1b5df3] px-5 py-4 text-white">Counting Down</h3>
          <p className="text-base m-0 w-full py-6"><i className="text-base fa fa-calendar text-[#1b5df3] px-5"></i>
            <Moment format='DD'>{data?.start_date}</Moment> - <Moment format='DD  MMMM y'>{data?.end_date}</Moment>
          </p>
        </div>
    </>
  )
}
